import { Action } from 'redux';
import { Blacklist } from '../entities';

export enum TBlacklist {
  SET_BLACKLIST = 'SET_BLACKLIST',
  BLACKLIST = 'BLACKLIST',
  UNBLACKLIST = 'UNBLACKLIST',
  FETCH_BLACKLIST = 'FETCH_BLACKLIST'
}

export interface ISetBlacklist extends Action {
  type: TBlacklist.SET_BLACKLIST;
  payload: Array<Blacklist>;
}
export const ASetBlacklist = (payload: Blacklist[]): ISetBlacklist => ({ type: TBlacklist.SET_BLACKLIST, payload });

export interface IBlacklist extends Action {
  type: TBlacklist.BLACKLIST;
  payload: Blacklist;
}
export const ABlacklist = (payload: Blacklist): IBlacklist => ({ type: TBlacklist.BLACKLIST, payload });

export interface IUnblacklist extends Action {
  type: TBlacklist.UNBLACKLIST;
  payload: string;
}
export const AUnblacklist = (payload: string): IUnblacklist => ({ type: TBlacklist.UNBLACKLIST, payload });

export interface IFetchBlacklist extends Action {
  type: TBlacklist.FETCH_BLACKLIST;
}
export const AFetchBlacklist = (): IFetchBlacklist => ({ type: TBlacklist.FETCH_BLACKLIST });
